import React from "react";
import { Box, Container } from "@mui/material";
import Paper from "../components/Paper";
import Typography from "../components/Typography";
import Button from "../components/Button";

export default function SubscriptionsWelcome({ setModalOpen }) {
  const handleClickWatchTutorial = () => setModalOpen(true);

  return (
    <Container maxWidth="sm" sx={{ flexGrow: 1 }}>
      <Box sx={{ mt: 2, mb: 4 }}>
        <Paper
          background="light"
          sx={{ py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}
        >
          <Typography variant="h3" gutterBottom marked="center" align="center" pb={4}>
            Welcome
          </Typography>
          <Typography variant="body2" align="justify">
            <p>This is your watch subscriptions dashboard, where you can add, edit, and delete watch subscriptions.</p>
            <p>When you create a watch subscription, you're signing up to receive email notifications when matching watches are posted to the Watch Exchange subreddit.</p>
            <p>Here's a 100 second video showing how to use this app!</p>
          </Typography>
          <Box sx={{ m: 2 }}>
            <Button 
              variant="contained"
              onClick={handleClickWatchTutorial}
              fullWidth
            >
              Watch Tutorial
            </Button>
          </Box>
          <Typography variant="body2" align="justify">
              <p>When you're ready, click the "Add Watch" button below to create your first watch subscription!</p>
            </Typography>
        </Paper>
      </Box>
    </Container>
  );
}
